import React from 'react';
import './PrintStyle.css';
import { Box, Grid, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import TitoLogo from '../assets/images/tito-logo.png';
import KKLogo from '../assets/images/kk-logo.png';
import moment from 'moment';

const OrderDetailPrint = React.forwardRef((props, ref) => {
    const { order, productList, comments, message } = props;

    const sumOfQtyOrder = productList?.reduce((total, item) => total + parseInt(item.qtyOrder?.replace(/\D/g, '') || 0), 0);
    const sumOfQtyDispatch = productList?.reduce((total, item) => total + parseInt(item.qtyDispatch?.replace(/\D/g, '') || 0), 0);

    const printStyles = `
        @media print {
            @page {
                size: A4;
                margin: 15mm;
            }
            body {
                print-color-adjust: exact;
                -webkit-print-color-adjust: exact;
            }
            table {
                page-break-inside: auto;
            }
            tr {
                page-break-inside: avoid;
                page-break-after: auto;
            }
            thead {
                display: table-header-group;
            }
            tfoot {
                display: table-footer-group;
            }
            .no-break {
                page-break-inside: avoid;
            }
            .header-section {
                page-break-after: avoid;
            }
        }
    `;

    return (
        <div ref={ref} style={{ padding: '30px', maxWidth: '210mm', margin: '0 auto' }}>
            <style>{printStyles}</style>
            
            <div className="header-section no-break" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 30 }}>
                <img src={KKLogo} alt="logo" style={{ height: 80, width: 80 }} />
                <h2 style={{ margin: 0 }}>KK Foods - Order Detail</h2>
                <img src={TitoLogo} alt="logo" style={{ height: 80, width: 80 }} />
            </div>

            <div className="no-break" style={{ marginBottom: 20 }}>
                <Grid container spacing={1} style={{ fontSize: '14px' }}>
                    <Grid item xs={6}>
                        <Typography style={{ fontSize: '14px' }}><strong>Order ID:</strong> {order?.serialNo}</Typography>
                    </Grid>
                    <Grid item xs={6}>
                        <Typography style={{ fontSize: '14px' }}><strong>Date:</strong> {moment(order?.createdOn).format('MMM DD, YYYY - hh:mm A')}</Typography>
                    </Grid>
                    <Grid item xs={6}>
                        <Typography style={{ fontSize: '14px' }}><strong>Customer Name:</strong> {order?.customer?.name}</Typography>
                    </Grid>
                    <Grid item xs={6}>
                        <Typography style={{ fontSize: '14px' }}>
                            <strong>Customer Phone:</strong> {order?.customer?.phoneNo}
                            {order?.customer?.phoneNo2 ? `, ${order?.customer?.phoneNo2}` : ''}
                        </Typography>
                    </Grid>
                    <Grid item xs={6}>
                        <Typography style={{ fontSize: '14px' }}><strong>Rep Name:</strong> {order?.user?.firstName} {order?.user?.lastName}</Typography>
                    </Grid>
                    <Grid item xs={6}>
                        <Typography style={{ fontSize: '14px' }}><strong>Status:</strong> {order?.status}</Typography>
                    </Grid>
                    {comments && (
                        <Grid item xs={12}>
                            <Typography style={{ fontSize: '14px' }}><strong>Comments:</strong> {comments}</Typography>
                        </Grid>
                    )}
                    {message && (
                        <Grid item xs={12}>
                            <Typography style={{ fontSize: '14px' }}><strong>Message:</strong> {message}</Typography>
                        </Grid>
                    )}
                </Grid>
            </div>

            <Typography variant="h6" style={{ marginBottom: 10, marginTop: 20, fontSize: '16px' }}>Order Items</Typography>
            <table style={{ 
                width: '100%', 
                borderCollapse: 'collapse',
                fontSize: '13px'
            }}>
                <thead style={{ backgroundColor: '#f5f5f5' }}>
                    <tr>
                        <th style={{ 
                            border: '1px solid #ddd', 
                            padding: '8px', 
                            textAlign: 'left',
                            fontWeight: 'bold'
                        }}>Product Name</th>
                        <th style={{ 
                            border: '1px solid #ddd', 
                            padding: '8px', 
                            textAlign: 'left',
                            fontWeight: 'bold'
                        }}>Packing</th>
                        <th style={{ 
                            border: '1px solid #ddd', 
                            padding: '8px', 
                            textAlign: 'right',
                            fontWeight: 'bold'
                        }}>Order Quantity</th>
                        <th style={{ 
                            border: '1px solid #ddd', 
                            padding: '8px', 
                            textAlign: 'right',
                            fontWeight: 'bold'
                        }}>Dispatch Quantity</th>
                    </tr>
                </thead>
                <tbody>
                    {productList?.map((row, index) => (
                        <tr key={index}>
                            <td style={{ 
                                border: '1px solid #ddd', 
                                padding: '6px',
                                pageBreakInside: 'avoid'
                            }}>{row?.product?.name}</td>
                            <td style={{ 
                                border: '1px solid #ddd', 
                                padding: '6px',
                                pageBreakInside: 'avoid'
                            }}>{row?.product?.packing || '-'}</td>
                            <td style={{ 
                                border: '1px solid #ddd', 
                                padding: '6px', 
                                textAlign: 'right',
                                pageBreakInside: 'avoid'
                            }}>{row?.qtyOrder}</td>
                            <td style={{ 
                                border: '1px solid #ddd', 
                                padding: '6px', 
                                textAlign: 'right',
                                pageBreakInside: 'avoid'
                            }}>{row?.qtyDispatch}</td>
                        </tr>
                    ))}
                    <tr style={{ backgroundColor: '#f5f5f5', fontWeight: 'bold' }}>
                        <td style={{ 
                            border: '1px solid #ddd', 
                            padding: '8px',
                            fontWeight: 'bold'
                        }}>Total</td>
                        <td style={{ 
                            border: '1px solid #ddd', 
                            padding: '8px',
                            fontWeight: 'bold'
                        }}></td>
                        <td style={{ 
                            border: '1px solid #ddd', 
                            padding: '8px', 
                            textAlign: 'right',
                            fontWeight: 'bold'
                        }}>{sumOfQtyOrder}</td>
                        <td style={{ 
                            border: '1px solid #ddd', 
                            padding: '8px', 
                            textAlign: 'right',
                            fontWeight: 'bold'
                        }}>{sumOfQtyDispatch}</td>
                    </tr>
                </tbody>
            </table>

            <div style={{ 
                marginTop: 30, 
                textAlign: 'center', 
                fontSize: '11px', 
                color: '#666',
                pageBreakInside: 'avoid'
            }}>
                <p style={{ margin: 0 }}>Printed on: {moment().format('MMM DD, YYYY - hh:mm A')}</p>
            </div>
        </div>
    );
});

export default OrderDetailPrint;
